module.exports = __webpack_public_path__ + "img/9-02-suteren.4bf5e071.jpg";